import axios from "axios";
import {environment} from "../environment";
import {AuthService} from "../services/auth.service";

const $clientApi = axios.create({
    baseURL: ""
});

const $authApi = axios.create({
    baseURL: environment.authServer
});

$clientApi.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${AuthService.gwtJWT()}`;
    return config;
});

$authApi.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${AuthService.gwtJWT()}`;
    return config;
});

export {$authApi, $clientApi};

